import {configureStore} from '@reduxjs/toolkit'
import {useDispatch, useSelector} from 'react-redux'
import {persistStore, persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import {commonSliceReducer} from '@/store/slices/commonSlice'
import themeReducer from './slices/themeSlice'
import {userDetailsSliceReducer} from '@/store/slices/userSlice'
import {appReducer} from '@/store/slices/appSlice'
import {notificationsReducer} from '@/store/slices/notificationSlice'

// Add persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['userDetails', 'theme'], // specify which reducers to persist
}

export const reducers = {
  common: commonSliceReducer,
  theme: themeReducer,
  userDetails: userDetailsSliceReducer,
  app: appReducer,
  notifications: notificationsReducer,
}

// Create the persisted reducer
const persistedReducer = persistReducer(
  persistConfig,
  // Need to use combineReducers since persistReducer expects a single reducer
  (state = {}, action) => {
    return Object.keys(reducers).reduce((nextState, key) => {
      nextState[key] = reducers[key](state[key], action)
      return nextState
    }, {})
  }
)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'], // Ignore persist actions
      },
    }),
})

export const useAppDispatch = () => useDispatch()
export const useAppSelector = useSelector
export const persistor = persistStore(store)
